import PatientDataCollection, { testIds } from './PatientDataCollection';
import extractPatientData from './extractPatientData';

export default PatientDataCollection;

export { extractPatientData, testIds };
